import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicChallengeBySlugV5ResponseSchema,
  type IChallengeV5,
} from './get-public-challenge-by-slug-v5-response';

export async function getPublicChallengeBySlugV5Api(slug: string) {
  return getRequest<IAPI<IChallengeV5>>({
    path: `/challenges/v5/slug/${encodeURIComponent(slug)}`,
    schema: getPublicChallengeBySlugV5ResponseSchema,
  });
}
